import { render, staticRenderFns } from "./RelatorioFiltros.vue?vue&type=template&id=3a4d8a0c&lang=pug"
import script from "./RelatorioFiltros.vue?vue&type=script&lang=js"
export * from "./RelatorioFiltros.vue?vue&type=script&lang=js"
import style0 from "./RelatorioFiltros.vue?vue&type=style&index=0&id=3a4d8a0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports